/* Policy Modal (privacy / terms / cookies) */ const modalOverlay = document.querySelector('.modal-overlay');
const modalCloseBtn = modalOverlay?.querySelector('.modal-close');
const modalBody = modalOverlay?.querySelector('.modal-body');
const modalContent = {
    privacy: document.querySelector('#privacy-policy-content'),
    terms: document.querySelector('#terms-content')
};
function openModal(key) {
    const template = modalContent[key];
    if (!template) return;
    modalBody.replaceChildren(template.content.cloneNode(true));
    modalOverlay.classList.add('active');
    document.body.classList.add('no-scroll');
}
function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
}
if (modalOverlay && modalCloseBtn && modalBody) {
    document.querySelectorAll('.policy-lnk').forEach((link)=>{
        link.addEventListener('click', (e)=>{
            e.preventDefault(); // href is empty, stop the page from reloading
            openModal(link.dataset.modal);
        });
    });
    modalCloseBtn.addEventListener('click', closeModal);
    // clicking the dark backdrop (not the modal itself) also closes it
    modalOverlay.addEventListener('click', (e)=>{
        if (e.target === modalOverlay) closeModal();
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && modalOverlay.classList.contains('active')) closeModal();
    });
}

//# sourceMappingURL=web-build.610202c6.js.map
